import React from 'react'
import BaseComponent from './BaseContainer'
import { graphql, compose, Query, withApollo } from 'react-apollo'
import EventLinks from '../components/list/EventLinks'
import getLinks from '../apollo/graphql/event/getLinks'
import getDetail from '../apollo/graphql/event/getDetail'
import { Loader, Message, Dimmer } from 'semantic-ui-react'

class EventLinksContainer extends BaseComponent {

  render () {
    return (
      <Query query={getLinks} variables={{ eventDetailId: this.props.match.params.detailId }} fetchPolicy='network-only'>
        {({ data, client, error, loading }) => {
          if (loading) {
            return (
              <Dimmer active inverted>
                <Loader inverted>Chargement</Loader>
              </Dimmer>
            )
          }
          if (error) {
            return (
              <Message negative>
                <Message.Header>Erreur</Message.Header>
                <p>{error.message}</p>
              </Message>
            )
          }
          return (
            <EventLinks objId={this.props.match.params.objId} links={data.getEventDetailLinks} detail={this.props.detail} />
          )
        }}
      </Query>
    )
  }
}

const EventLinksContainerEnhanced = compose(
  graphql(getDetail, {
    name: 'detail',
    options: (props) => {
      return {
        variables: {
          eventDetailId: props.match.params.detailId
        },
        fetchPolicy: 'network-only'
      }
    }
  }),
)(EventLinksContainer)

export default withApollo(EventLinksContainerEnhanced)



// WEBPACK FOOTER //
// ./src/containers/EventLinksContainer.js